import { jsx as _jsx } from "react/jsx-runtime";
import { SignUp } from "@clerk/clerk-react";
import Center from "../components/Center";
const SignUpPage = () => {
    return (_jsx(Center, { children: _jsx(SignUp, { path: "/sign-up", routing: "path", signInUrl: "/sign-in" }) }));
};
export default SignUpPage;
